import React from 'react';
import cn from 'classnames'
import Link from 'gatsby-link';
import Button from '../Button';

import './styles.scss';

const menu = [{
  label: 'O nas',
  to: '/o-nas'
}, {
  label: 'Sztuka i rozrywka',
  to: '/sztuka-i-rozrywka'
}, {
  label: 'Technika estradowa',
  to: '/technika-estradowa'
}, {
  label: 'Organizacja wydarzeń',
  to: '/organizacja-wydarzen'
}]

const getActiveLink = (to) => {
  if(typeof window === "undefined") { return false; }
  return window.location.pathname === to;
}

const Menu = (props) => {
  const menuStyles = cn('menu', {
    'menu--active': props.active,
  });

  return (
      <div className={menuStyles}>
      <div className="menu__content">    
        <nav className="menu__nav">
          <ul className="menu__list">
            {menu.map(link => {
              const classNames = cn('menu__link', {
                'menu__link--active': getActiveLink(link.to),
              })
              return (
                <li className="menu__element" key={link.label}>
                  <Link to={link.to} className={classNames} onClick={props.onClick}>{link.label}</Link>
                </li>
              )
            }
            )}
          </ul>
        </nav>
        <div style={{marginTop: '30px'}}>
          <Button type="yellow" label="Napisz do nas!" mailto="mailto:kontakt@customart.pl"/>
        </div>
      </div>
    </div>
  )
};

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu/index.js